import type { ConfigType } from '@plone/registry';

export default function install(config: ConfigType) {
  // Language settings
  config.settings.defaultLanguage = 'en';
  // Additional language settings for Volto 19 and above, add as many supported languages as needed
  // Languages not added to supportedLanguages will not be included in the build
  // config.settings.supportedLanguages = ['en'];

  // Files open in the browser (PDFs show inline; other types still save).
  // Volto's default sends visitors to @@download, which forces a download.
  // Don't list a type in both settings: the two suffixes would stack.
  config.settings.downloadableObjects = [];
  config.settings.viewableInBrowserObjects = ['File'];

  return config;
}
